import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import Content from './components/Content'

import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'

import './style.scss'

@HocDialogComponent
export default class About extends Component {
    static propTypes = {
        closeDialog: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
    }

    onButtonClick = (buttonType) => {
        if (buttonType === 'close') {
            const { type, closeDialog } = this.props

            closeDialog(type)
        }
    }

    defineHeader = () => ({
        text: ' ',
        icon: 'gnosus',
    })

    defineFooter = () => [
        {
            type: 'close',
            text: <FormattedMessage id={`${LOCALE_PREFIX}.button.close`} />,
        },
    ]

    render() {
        return (
            <div className={'about-dialog'}>
                <Content id={'about_dialog'} />
            </div>
        )
    }
}
